/**
 * Event Service
 * Historical events service API: a read-only record of what happened inside a Convercus loyalty program. It serves the stored event history for accounts, memberships and users, for coupons, for news posts and for workflows, filtered by subject, date range, originating user and event type. Every endpoint is a paginated read; the service never writes, edits or replays events.
 *
 * The version of the OpenAPI document: v1.0.37758
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { NewsDto } from './news-dto';


export interface NewsEventDto { 
    /**
     * Event ID
     */
    _id: string;
    /**
     * New Event type
     */
    eventType: NewsEventDto.EventTypeEnum;
    /**
     * Subject information
     */
    subject: NewsDto;
    /**
     * Program identifier
     */
    program: string;
    /**
     * Creation timestamp
     */
    createdAt: string;
    /**
     * Username who generated the event
     */
    userName: string;
    /**
     * User ID who generated the event
     */
    userId: string;
}
export namespace NewsEventDto {
    export type EventTypeEnum = 'NEWS_CREATED' | 'NEWS_DELETED' | 'NEWS_REPLACE' | 'NEWS_UPDATED';
    export const EventTypeEnum = {
        Created: 'NEWS_CREATED' as EventTypeEnum,
        Deleted: 'NEWS_DELETED' as EventTypeEnum,
        Replace: 'NEWS_REPLACE' as EventTypeEnum,
        Updated: 'NEWS_UPDATED' as EventTypeEnum
    };
}


